import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import PopupHeader from '../../popupHeader';
import Modal from 'components/shared/modal/content';
import { showDeleteTagFromOUConfirmationModal } from 'actions/modal.js';
import { displayGlobalMessage } from 'actions/globalMessage';
import {
  deleteTagFromOU,
  getOrgUnitTags,
  getAvailableTagsByNetworkId,
  clearTempAssignTagsObjectInOU,
} from 'actions/organisation.js';

export default function RemoveTagConfirmationContent(props) {
  const dispatch = useDispatch();
  const [removingTagfromWA, setRemovingTagfromWA] = useState(false);
  const selectedTagObject = useSelector((state) => state.organisationsReducer.selectedTagObject);

  const confirmRemovingTagFromWA = () => {
    setRemovingTagfromWA(true);

    let cb = (hideOrNot) => {
      let succesfulMessage =
        APP.LANGUAGE.OrganisationalUnitManageTags.RemoveTagModal.DeleteTagSuccessfulMessage.replace(
          '##tagName##',
          selectedTagObject.tagName
        );

      let cbAfterGettingTags = () => {
        setRemovingTagfromWA(true);

        dispatch(showDeleteTagFromOUConfirmationModal(hideOrNot));
        if (!hideOrNot) {
          dispatch(clearTempAssignTagsObjectInOU());
          dispatch(
            displayGlobalMessage({
              text: succesfulMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        }
      };
      dispatch(getAvailableTagsByNetworkId(props.orgUnit.networkId));
      dispatch(getOrgUnitTags(props.orgUnit.networkId, cbAfterGettingTags));
    };
    if (!!selectedTagObject) {
      dispatch(deleteTagFromOU(props.orgUnit.networkId, selectedTagObject, cb));
    }
  };

  const closeConfirmationModal = () => {
    dispatch(showDeleteTagFromOUConfirmationModal(false));
    dispatch(clearTempAssignTagsObjectInOU());
  };

  const removeBtnClasses =
    'ui labeled icon button icon left-text color-button mrbnull color-button-hover mrpcrxs color-white mrlnull max-width';
  return (
    <Modal show={true} hideWhenClickAway={false} isSingleColumnModal={true} className="remove-tag single-column-modal">
      <PopupHeader hideHelp={true} title={window.APP.LANGUAGE.OrganisationalUnitManageTags.RemoveTagModal.Title} />
      <div className="content">
        <div className="main-ui-container content-horizontally-centred mrrnull">
          <div id="righthandfloatingpanel">
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <h4 className="title-sms">
                {window.APP.LANGUAGE.OrganisationalUnitManageTags.RemoveTagModal.ConfirmationRemoveTagCaption.replace(
                  '##deletedTagName##',
                  selectedTagObject.tagName
                ).replace('##orgUnitName##', props.orgUnit.name)}
              </h4>
              <div className="ui actions max-width">
                <button
                  type="button"
                  id="remove-save-btn"
                  onClick={confirmRemovingTagFromWA}
                  className={removingTagfromWA ? removeBtnClasses + ' loading remove-save-btn' : removeBtnClasses}
                >
                  {APP.LANGUAGE.Yes}
                  <i className="checkmark icon " />
                </button>
                <button
                  onClick={closeConfirmationModal}
                  type="button"
                  id="remove-cancel-btn"
                  className="ui cancel mrtm labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width  mrlnull mrbnull mrrnull"
                >
                  <i className="remove  icon" />
                  {APP.LANGUAGE.Cancel}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

RemoveTagConfirmationContent.propTypes = {
  orgUnit: PropTypes.object.isRequired,
  selectedTagObject: PropTypes.object.isRequired,
};
